"use client";

/**
 * Renders its children at the end of <body>, outside the page. Every full-screen overlay (dialogs, drawers,
 * sheets, the search palette) goes through it: inside the page, an animated or transformed parent (the page
 * fade-in, a card's hover lift) traps `position: fixed`, so the backdrop would cover only part of the screen
 * and sit under the sidebar and top bar.
 */
import { useEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

export function Portal({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false);
  // eslint-disable-next-line react-hooks/set-state-in-effect -- document.body exists only after mounting
  useEffect(() => setReady(true), []);
  return ready ? createPortal(children, document.body) : null;
}
